import { render, staticRenderFns } from "./AddContactModal.vue?vue&type=template&id=3867a478&scoped=true"
import script from "./AddContactModal.vue?vue&type=script&lang=js"
export * from "./AddContactModal.vue?vue&type=script&lang=js"
import style0 from "./AddContactModal.vue?vue&type=style&index=0&id=3867a478&prod&scoped=true&lang=scss"
import style1 from "./AddContactModal.vue?vue&type=style&index=1&id=3867a478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867a478",
  null
  
)

export default component.exports